import { render, staticRenderFns } from "./ForgetPasswordDialog.vue?vue&type=template&id=32fcf755&scoped=true"
import script from "./ForgetPasswordDialog.vue?vue&type=script&lang=js"
export * from "./ForgetPasswordDialog.vue?vue&type=script&lang=js"
import style0 from "./ForgetPasswordDialog.vue?vue&type=style&index=0&id=32fcf755&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fcf755",
  null
  
)

export default component.exports